@if (!userDetails?.email) {
  <app-user-details [emailConfirmation]="true" (validated)="onUserDetails($event)"></app-user-details>
}
@if (userDetails?.email) {
  <app-password [requestOld]="false" (passwordValidated)="register($event)"></app-password>
}
